/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import AccordianItemwithImage from '../components/AccordianItemwithImage';
import AccordianItemwithImageIcon from '../components/AccordianItemwithImageIcon';
import AccordianSection from '../components/AccordianSection';
import Accordion from '../components/Accordion';
import AccountDeletion from '../components/AccountDeletion';
import AccountSecurity from '../components/AccountSecurity';
import ActivateCard from '../components/ActivateCard';
import AddCard from '../components/AddCard';
import AddContactlessCard from '../components/AddContactlessCard';
import AddFunds from '../components/AddFunds';
import AddPrestoCard from '../components/AddPrestoCard';
import AnchorComponent from '../components/AnchorComponent';
import Autoload from '../components/Autoload';
import B2CAccountCreation from '../components/B2CAccountCreation';
import B2CError from '../components/B2CError';
import B2CPersonalInformation from '../components/B2CPersonalInformation';
import BalanceBlock from '../components/BalanceBlock';
import CancelAutoload from '../components/CancelAutoload';
import CancelAutorenew from '../components/CancelAutorenew';
import Card from '../components/Card';
import CardItem from '../components/CardItem';
import Carousel from '../components/Carousel';
import CarouselSlide from '../components/CarouselSlide';
import CaslPopUp from '../components/CaslPopUp';
import ChangePIN from '../components/ChangePIN';
import Checkout from '../components/Checkout';
import ContactlessAccountCardImage from '../components/ContactlessAccountCardImage';
import ContactlessFooter from '../components/ContactlessFooter';
import ContactlessLeftNavigationFAQ from '../components/ContactlessLeftNavigationFAQ';
import ContactLessSignInOverlay from '../components/ContactLessSignInOverlay';
import ContactlessTopNavigation from '../components/ContactlessTopNavigation';
import ContactlessTransactionHistory from '../components/ContactlessTransactionHistory';
import ContactlessUnpaidFare from '../components/ContactlessUnpaidFare';
import ContactUsForm from '../components/ContactUsForm';
import ContentBlock from '../components/ContentBlock';
import ContentPageLayout from '../components/ContentPageLayout';
import Copyright from '../components/Copyright';
import CreateAccount from '../components/CreateAccount';
import CSOLocator from '../components/CSOLocator';
import CTAButton from '../components/CTAButton';
import Dashboard from '../components/Dashboard';
import DeactivateCard from '../components/DeactivateCard';
import DeleteAccount from '../components/DeleteAccount';
import DeleteAccountSuccess from '../components/DeleteAccountSuccess';
import DigitalDistributionServices from '../components/DigitalDistributionServices';
import Divider from '../components/Divider';
import EmailVerification from '../components/EmailVerification';
import ErrorPage from '../components/ErrorPage';
import FeaturesBlock from '../components/FeaturesBlock';
import Footer from '../components/Footer';
import ForgotPassword from '../components/ForgotPassword';
import ForgotUsername from '../components/ForgotUsername';
import FourthcolumnLayout from '../components/FourthcolumnLayout';
import FullScreenLayout from '../components/FullScreenLayout';
import FullWidthLayout from '../components/FullWidthLayout';
import GlobalNotification from '../components/GlobalNotification';
import godefaulttrip from '../components/godefaulttrip';
import GoogleMap from '../components/GoogleMap';
import GuestSignin from '../components/GuestSignin';
import Heading from '../components/Heading';
import HeroBannerWithBackground from '../components/HeroBannerWithBackground';
import HeroBannerWithButton from '../components/HeroBannerWithButton';
import ImageCTALinkable from '../components/ImageCTALinkable';
import ImageParagraphwithButton from '../components/ImageParagraphwithButton';
import ImageWithParagraph from '../components/ImageWithParagraph';
import ImageWithProcessStep from '../components/ImageWithProcessStep';
import ImageWithWalletInfo from '../components/ImageWithWalletInfo';
import LeftNavigation from '../components/LeftNavigation';
import LoadMyCard from '../components/LoadMyCard';
import LoginAndSecurityMessage from '../components/LoginAndSecurityMessage';
import LoyaltySummary from '../components/LoyaltySummary';
import MainHeroBanner from '../components/MainHeroBanner';
import ManageAutoload from '../components/ManageAutoload';
import ManageAutoRenew from '../components/ManageAutoRenew';
import ManageMyProducts from '../components/ManageMyProducts';
import ModifyAutoload from '../components/ModifyAutoload';
import MyProductsOverview from '../components/MyProductsOverview';
import MyProductsPage from '../components/MyProductsPage';
import NotificationBanner from '../components/NotificationBanner';
import Notifications from '../components/Notifications';
import OrderaCard from '../components/OrderaCard';
import PageHeading from '../components/PageHeading';
import ParagraphContent from '../components/ParagraphContent';
import PasswordChange from '../components/PasswordChange';
import PersonalInformation from '../components/PersonalInformation';
import PrestocardSignin from '../components/PrestocardSignin';
import RedeemVoucher from '../components/RedeemVoucher';
import RedeemVoucherStepperBlock from '../components/RedeemVoucherStepperBlock';
import Redirection from '../components/Redirection';
import RegisteredAccount from '../components/RegisteredAccount';
import ReportLostCard from '../components/ReportLostCard';
import SavedPaymentMethod from '../components/SavedPaymentMethod';
import SearchResults from '../components/SearchResults';
import SecurityAlerts from '../components/SecurityAlerts';
import SetAutoload from '../components/SetAutoload';
import SetAutorenew from '../components/SetAutorenew';
import SideNavigation from '../components/SideNavigation';
import Signin from '../components/Signin';
import SigninSidebar from '../components/SigninSidebar';
import SigninSuccess from '../components/SigninSuccess';
import Sitemap from '../components/Sitemap';
import SogrButton from '../components/SogrButton';
import SystemStatusMessage from '../components/SystemStatusMessage';
import TargetedMessage from '../components/TargetedMessage';
import TermsAndConditions from '../components/TermsAndConditions';
import ThirdcolumnLayout from '../components/ThirdcolumnLayout';
import ThumbnailCollection from '../components/ThumbnailCollection';
import ThumbnailCollections from '../components/ThumbnailCollections';
import TopNavigation from '../components/TopNavigation';
import TopNavigationAnonymous from '../components/TopNavigationAnonymous';
import TopNavigationAuthenticated from '../components/TopNavigationAuthenticated';
import TopNavigationUnAuthenticated from '../components/TopNavigationUnAuthenticated';
import TransactionHistory from '../components/TransactionHistory';
import TransactionHistoryContactless from '../components/TransactionHistoryContactless';
import TransactionHistoryPresto from '../components/TransactionHistoryPresto';
import TransitAgencyList from '../components/TransitAgencyList';
import TransitPass from '../components/TransitPass';
import TransitUsageReport from '../components/TransitUsageReport';
import TwoColumnImagesContent from '../components/TwoColumnImagesContent';
import TwocolumnLayout from '../components/TwocolumnLayout';
import TwoStepVerification from '../components/TwoStepVerification';
import UnlinkCard from '../components/UnlinkCard';
import UnpaidFares from '../components/UnpaidFares';
import UpdateCardNickName from '../components/UpdateCardNickName';
import UpdatePersonalInformation from '../components/UpdatePersonalInformation';
import VerifyEmailLink from '../components/VerifyEmailLink';
import VirtualAssistant from '../components/VirtualAssistant';

const components = new Map();
components.set('AccordianItemwithImage', AccordianItemwithImage);
components.set('AccordianItemwithImageIcon', AccordianItemwithImageIcon);
components.set('AccordianSection', AccordianSection);
components.set('Accordion', Accordion);
components.set('AccountDeletion', AccountDeletion);
components.set('AccountSecurity', AccountSecurity);
components.set('ActivateCard', ActivateCard);
components.set('AddCard', AddCard);
components.set('AddContactlessCard', AddContactlessCard);
components.set('AddFunds', AddFunds);
components.set('AddPrestoCard', AddPrestoCard);
components.set('AnchorComponent', AnchorComponent);
components.set('Autoload', Autoload);
components.set('B2CAccountCreation', B2CAccountCreation);
components.set('B2CError', B2CError);
components.set('B2CPersonalInformation', B2CPersonalInformation);
components.set('BalanceBlock', BalanceBlock);
components.set('CancelAutoload', CancelAutoload);
components.set('CancelAutorenew', CancelAutorenew);
components.set('Card', Card);
components.set('CardItem', CardItem);
components.set('Carousel', Carousel);
components.set('CarouselSlide', CarouselSlide);
components.set('CaslPopUp', CaslPopUp);
components.set('ChangePIN', ChangePIN);
components.set('Checkout', Checkout);
components.set('ContactlessAccountCardImage', ContactlessAccountCardImage);
components.set('ContactlessFooter', ContactlessFooter);
components.set('ContactlessLeftNavigationFAQ', ContactlessLeftNavigationFAQ);
components.set('ContactLessSignInOverlay', ContactLessSignInOverlay);
components.set('ContactlessTopNavigation', ContactlessTopNavigation);
components.set('ContactlessTransactionHistory', ContactlessTransactionHistory);
components.set('ContactlessUnpaidFare', ContactlessUnpaidFare);
components.set('ContactUsForm', ContactUsForm);
components.set('ContentBlock', ContentBlock);
components.set('ContentPageLayout', ContentPageLayout);
components.set('Copyright', Copyright);
components.set('CreateAccount', CreateAccount);
components.set('CSOLocator', CSOLocator);
components.set('CTAButton', CTAButton);
components.set('Dashboard', Dashboard);
components.set('DeactivateCard', DeactivateCard);
components.set('DeleteAccount', DeleteAccount);
components.set('DeleteAccountSuccess', DeleteAccountSuccess);
components.set('DigitalDistributionServices', DigitalDistributionServices);
components.set('Divider', Divider);
components.set('EmailVerification', EmailVerification);
components.set('ErrorPage', ErrorPage);
components.set('FeaturesBlock', FeaturesBlock);
components.set('Footer', Footer);
components.set('ForgotPassword', ForgotPassword);
components.set('ForgotUsername', ForgotUsername);
components.set('FourthcolumnLayout', FourthcolumnLayout);
components.set('FullScreenLayout', FullScreenLayout);
components.set('FullWidthLayout', FullWidthLayout);
components.set('GlobalNotification', GlobalNotification);
components.set('godefaulttrip', godefaulttrip);
components.set('GoogleMap', GoogleMap);
components.set('GuestSignin', GuestSignin);
components.set('Heading', Heading);
components.set('HeroBannerWithBackground', HeroBannerWithBackground);
components.set('HeroBannerWithButton', HeroBannerWithButton);
components.set('ImageCTALinkable', ImageCTALinkable);
components.set('ImageParagraphwithButton', ImageParagraphwithButton);
components.set('ImageWithParagraph', ImageWithParagraph);
components.set('ImageWithProcessStep', ImageWithProcessStep);
components.set('ImageWithWalletInfo', ImageWithWalletInfo);
components.set('LeftNavigation', LeftNavigation);
components.set('LoadMyCard', LoadMyCard);
components.set('LoginAndSecurityMessage', LoginAndSecurityMessage);
components.set('LoyaltySummary', LoyaltySummary);
components.set('MainHeroBanner', MainHeroBanner);
components.set('ManageAutoload', ManageAutoload);
components.set('ManageAutoRenew', ManageAutoRenew);
components.set('ManageMyProducts', ManageMyProducts);
components.set('ModifyAutoload', ModifyAutoload);
components.set('MyProductsOverview', MyProductsOverview);
components.set('MyProductsPage', MyProductsPage);
components.set('NotificationBanner', NotificationBanner);
components.set('Notifications', Notifications);
components.set('OrderaCard', OrderaCard);
components.set('PageHeading', PageHeading);
components.set('ParagraphContent', ParagraphContent);
components.set('PasswordChange', PasswordChange);
components.set('PersonalInformation', PersonalInformation);
components.set('PrestocardSignin', PrestocardSignin);
components.set('RedeemVoucher', RedeemVoucher);
components.set('RedeemVoucherStepperBlock', RedeemVoucherStepperBlock);
components.set('Redirection', Redirection);
components.set('RegisteredAccount', RegisteredAccount);
components.set('ReportLostCard', ReportLostCard);
components.set('SavedPaymentMethod', SavedPaymentMethod);
components.set('SearchResults', SearchResults);
components.set('SecurityAlerts', SecurityAlerts);
components.set('SetAutoload', SetAutoload);
components.set('SetAutorenew', SetAutorenew);
components.set('SideNavigation', SideNavigation);
components.set('Signin', Signin);
components.set('SigninSidebar', SigninSidebar);
components.set('SigninSuccess', SigninSuccess);
components.set('Sitemap', Sitemap);
components.set('SogrButton', SogrButton);
components.set('SystemStatusMessage', SystemStatusMessage);
components.set('TargetedMessage', TargetedMessage);
components.set('TermsAndConditions', TermsAndConditions);
components.set('ThirdcolumnLayout', ThirdcolumnLayout);
components.set('ThumbnailCollection', ThumbnailCollection);
components.set('ThumbnailCollections', ThumbnailCollections);
components.set('TopNavigation', TopNavigation);
components.set('TopNavigationAnonymous', TopNavigationAnonymous);
components.set('TopNavigationAuthenticated', TopNavigationAuthenticated);
components.set('TopNavigationUnAuthenticated', TopNavigationUnAuthenticated);
components.set('TransactionHistory', TransactionHistory);
components.set('TransactionHistoryContactless', TransactionHistoryContactless);
components.set('TransactionHistoryPresto', TransactionHistoryPresto);
components.set('TransitAgencyList', TransitAgencyList);
components.set('TransitPass', TransitPass);
components.set('TransitUsageReport', TransitUsageReport);
components.set('TwoColumnImagesContent', TwoColumnImagesContent);
components.set('TwocolumnLayout', TwocolumnLayout);
components.set('TwoStepVerification', TwoStepVerification);
components.set('UnlinkCard', UnlinkCard);
components.set('UnpaidFares', UnpaidFares);
components.set('UpdateCardNickName', UpdateCardNickName);
components.set('UpdatePersonalInformation', UpdatePersonalInformation);
components.set('VerifyEmailLink', VerifyEmailLink);
components.set('VirtualAssistant', VirtualAssistant);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
